import { get } from "lodash"
import { string } from "yup"
import { Input } from "@4cplatform/elements/Forms"
import UnderwritingTermsInput from "./underwritingTermsInput"

export const config = data => ({
  title: "Additional details to submit to provider",
  subtitle:
    "Please add any additional information that the provider will need to know to process the application. This will be sent to the provider along with the application.",
  sections: [
    {
      key: "section_1",
      components: [
        {
          key: "underwriting_reference",
          initialValue: get(data, "page.data.underwriting_reference", ""),
          validationSchema: string().nullable(),
          label: "Underwriting reference",
          component: Input,
          componentProps: {
            isHorizontal: true,
            margin: "0 0 2rem"
          }
        },
        {
          key: "underwriting_terms_provided_by_the_insurer",
          initialValue: get(data, "page.data.underwriting_terms_provided_by_the_insurer", ""),
          validationSchema: string().nullable().max(1000),
          label: "Underwriting terms provided by the insurer",
          component: UnderwritingTermsInput,
          componentProps: {
            isHorizontal: true,
            margin: "0 0 2rem",
            maxLength: 1000,
            shouldDisplayEmptyOption: false
          }
        }
      ]
    }
  ]
})
